import { CreditCardIssuer } from "src/api";
import { CreditCardType } from "src/invoice/types/types";


export const getCardType = (cardNumber: string) => {
    if (cardNumber.match(/^4[0-9]{6,}$/)) {
        return CreditCardType.Visa;
    } else if (cardNumber.match(/^3[47][0-9]{5,}$/)) {
        return CreditCardType.AmericanExpress;
    } else if (cardNumber.match(/^6(?:011|5[0-9]{2})[0-9]{3,}$/)) {
        return CreditCardType.Discover;
    } else if (cardNumber.match(/^5[1-5][0-9]{5,}|222[1-9][0-9]{3,}|22[3-9][0-9]{4,}|2[3-6][0-9]{5,}|27[01][0-9]{4,}|2720[0-9]{3,}$/)) {
        return CreditCardType.MasterCard;
    }

    return CreditCardType.Other;
};

export const getCardIcon = (cardType: string) => {
    return cardType === CreditCardType.Visa ? 'assets/images/visa.svg' :
        cardType === CreditCardType.AmericanExpress ? 'assets/images/american-express.svg' :
            cardType === CreditCardType.Discover ? 'assets/images/discover-card.svg' :
                cardType === CreditCardType.MasterCard ? 'assets/images/mastercard.svg' : '';
};

export const getCardNameByIssuer = (issuer: CreditCardIssuer) => {
    return issuer === CreditCardIssuer.NUMBER_3 ? CreditCardType.AmericanExpress :
        issuer === CreditCardIssuer.NUMBER_4 ? CreditCardType.Visa :
            issuer === CreditCardIssuer.NUMBER_5 ? CreditCardType.MasterCard :
                issuer === CreditCardIssuer.NUMBER_6 ? CreditCardType.Discover :
                    CreditCardType.Other;
};

export const getIssuerByCardType = (cardType: string | undefined) => {
    return cardType === CreditCardType.AmericanExpress ? CreditCardIssuer.NUMBER_3 :
        cardType === CreditCardType.Visa ? CreditCardIssuer.NUMBER_4 :
            cardType === CreditCardType.MasterCard ? CreditCardIssuer.NUMBER_5 :
                cardType === CreditCardType.Discover ? CreditCardIssuer.NUMBER_6 :
                    CreditCardIssuer.NUMBER_0;
}